import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import PartnerWithBoost from "./sections/PartnerWithBoost";
import OurLocation from "./sections/OurLocation";
import VolunteerApplication from "./sections/VolunteerApplication";
import FooterInfo from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <PartnerWithBoost />
      <OurLocation />
      <VolunteerApplication />
      <FooterInfo />
    </div>;
}